import generalInit from './modules/general';
import slidersInit from './modules/sliders';
import menuInit from './modules/menu';
import galleryInit from './modules/wp-gallery';
import loadMoreInit from './modules/loadmore';



(function ($) {


	// $(document).foundation();

	$(document).ready(function () {

		generalInit();
		slidersInit();
		menuInit();
		galleryInit();
		loadMoreInit();

		//menu-sticy
		$(window).scroll(function () {
			if ($(window).width() >= 980) {
				if ($(this).scrollTop() > 1) {
					$('#navbar').addClass("sticky");
					$('.header-main').removeClass("stretch-left grid-container-left");
					$('.logo-box-box').addClass("medium-6 large-6");
					$('.logo-box-box').removeClass("medium-5 large-4");

				} else {
					$('#navbar').removeClass("sticky");
					$('.header-main').addClass("stretch-left grid-container-left");
					$('.logo-box-box').removeClass("medium-6 large-6");
					$('.logo-box-box').addClass("medium-5 large-4");
				}

			}
		});


		//matchHeight



		// // When the user scrolls the page, execute myFunction
		// window.onscroll = function() {myFunction()};

		// // Get the navbar
		// var navbar = document.getElementById("navbar");

		// // Get the offset position of the navbar
		// var sticky = navbar.offsetTop;

		// // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
		// function myFunction() {
		//   if (window.pageYOffset >= sticky) {
		//     navbar.classList.add("sticky")
		//   } else {
		//     navbar.classList.remove("sticky");
		//   }
		// }





		// $(".single-ofert .big-title").matchHeight();

		//dynamic-class-single_ofert

		//toggle with arrow

		// $(' .big-li').click(function () {

		// 	let element_id = $(this).attr('data-show-panel');
		// 	let name = ".toggle-li-" + element_id;
		// 	$(name).slideToggle();
		// 	console.log(name);

		// });

		//show-big-li-text

	//	$('.dynamic-left .menu-item-has-children').click(function (e) {
			//e.preventDefault()
		//	let element_id = $(this).attr('data-show-panel');
		//	let target = ".panel-" + element_id;
		//	$(target).show();
		//	$('.dynamic-left .sub-menu').slideToggle();
		//	$(this).addClass("add-opacity");
	//		$(this).siblings().removeClass("add-opacity");
		//	$(target).siblings().hide();
	//	})

		//show small-li text

		// $('body').on('click', '.small-li', function (e) {
		// 	e.preventDefault()
		// 	let element_id = $(this).attr('data-show-small');
		// 	let target = ".small-li-" + element_id;
		// 	$(target).show();
		// 	$(this).addClass("add-opacity");
		// 	$(this).siblings().removeClass("add-opacity");
		// 	$(target).siblings().hide();
		// });

		///////////////map

		$('.map-title h3').click(function () {
			// $('.map-image').slideToggle();

			$('html,body').animate({
				scrollTop: $(this).offset().top
			}, 500);
		});

		//////////////////job-toggle
		$(".offer").click(function () {


			let id_faq = $(this).attr('data-show-offer');
			let target = '.offer-text-' + id_faq;
			if ($(".offer-text:visible").not($(target)).length) {
				$(".offer-text").hide();
				// $(".offer-text").slideUp();

				$(this).siblings().removeClass('offer-added-class rotate');
			}

			$(this).toggleClass('offer-added-class rotate');
			$(target).slideToggle();




		});

		// $(".offer:first-child").click(function () {
		// 	$('html,body').delay(500).animate({
		// 		scrollTop: $(this).offset().top - 180
		// 	}, 'slow');
		// });
		// $(".offer:not(:first-child)").click(function () {
		// 	$('html,body').delay(500).animate({
		// 		scrollTop: $(this).offset().top - 100
		// 	}, 'slow');
		// });
		$(".offer").click(function () {
			$('html,body').animate({
				scrollTop: $(this).offset().top - 100
			}, 'slow');
		});






	});


	/**
		*Scroll to anchor
		*/

	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
				&&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1050, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});






})(jQuery);